'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * A hook for returning a debounced value after a delay.
 *
 * From: https://www.byteconf.com/blog/debouncing-with-react-hooks
 */

function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  // State and setters for debounced value
  var [debouncedValue, setDebouncedValue] = React__namespace.useState(value);
  React__namespace.useEffect(() => {
    // Set debouncedValue to value (passed in) after the specified delay
    var handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay); // Return a cleanup function that will be called every time
    // useEffect is re-called. useEffect will only be re-called
    // if value changes (see the inputs array below).
    // This is how we prevent debouncedValue from changing if value is
    // changed within the delay period.
    // To put it in context, if the user is typing within our app's
    // search box, we don't want the debouncedValue to update until
    // they've stopped typing for more than 500ms.

    return () => {
      clearTimeout(handler);
    };
  }, // Only re-call effect if value changes
  // You could also add the "delay" var to inputs array if you
  // need to be able to change that dynamically.
  [value, delay]);
  return debouncedValue;
}

exports.default = useDebounce;
exports.useDebounce = useDebounce;
